namespace TabAurous.OMS {
    export interface ProductMasterForm {
        ProductId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        ItemTypeId: Serenity.IntegerEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BrandId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        AttributeId: Serenity.StringEditor;
        CalcOnId: Serenity.LookupEditor;
        CalcUnitId: Serenity.LookupEditor;
        MetalId: Serenity.LookupEditor;
        KaratId: Serenity.LookupEditor;
        MetalColorId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        ProductSizeId: CommonProductSizeLookup;
        IsDefaultSKU: Serenity.BooleanEditor;
        SKU: Serenity.StringEditor;
        CostMethodId: Serenity.EnumEditor;
        HasBom: Serenity.BooleanEditor;
        ForExchange: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        IsNew: Serenity.BooleanEditor;
        IsFeatured: Serenity.BooleanEditor;
        IsConfigurable: Serenity.BooleanEditor;
        MappingId: Serenity.LookupEditor;
        Parts: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Variance: Serenity.DecimalEditor;
        PointerWeight: Serenity.DecimalEditor;
        Rate: Serenity.DecimalEditor;
        UnitLabour: Serenity.DecimalEditor;
        PriceMarkup: Serenity.DecimalEditor;
        LaborMarkup: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        OtherWeight: Serenity.DecimalEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        Image2: Serenity.ImageUploadEditor;
        Image3: Serenity.ImageUploadEditor;
        Remarks: Serenity.StringEditor;
        BOMDetails: ProductBOMEditor;
        LaborDetails: ProductMasterLaborEditor;
        InspectionDetails: ProductInspectionEditor;
        SequenceDetails: ProductSequenceEditor;
        MoldsDetails: ProductMoldsEditor;
        SalesCostMethodId: Serenity.EnumEditor;
        PurchaseCostMethodId: Serenity.EnumEditor;
        HSN: Serenity.LookupEditor;
        TaxCode: Serenity.LookupEditor;
        Image4: Serenity.ImageUploadEditor;
        Image5: Serenity.ImageUploadEditor;
        Image6: Serenity.ImageUploadEditor;
        Image7: Serenity.ImageUploadEditor;
        Image8: Serenity.ImageUploadEditor;
        Video1: Serenity.ImageUploadEditor;
        Video2: Serenity.ImageUploadEditor;
        ProductPartyDetails: ProductPartyDetailsEditor;
    }

    export class ProductMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductMasterForm.init)  {
                ProductMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = s.DecimalEditor;
                var w6 = CommonProductSizeLookup;
                var w7 = s.BooleanEditor;
                var w8 = s.EnumEditor;
                var w9 = s.ImageUploadEditor;
                var w10 = ProductBOMEditor;
                var w11 = ProductMasterLaborEditor;
                var w12 = ProductInspectionEditor;
                var w13 = ProductSequenceEditor;
                var w14 = ProductMoldsEditor;
                var w15 = ProductPartyDetailsEditor;

                Q.initFormType(ProductMasterForm, [
                    'ProductId', w0,
                    'ProductCode', w0,
                    'ProductName', w0,
                    'ProductTypeId', w1,
                    'ItemTypeId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BrandId', w1,
                    'CollectionId', w1,
                    'SuperTypeId', w1,
                    'AttributeId', w0,
                    'CalcOnId', w1,
                    'CalcUnitId', w1,
                    'MetalId', w1,
                    'KaratId', w1,
                    'MetalColorId', w1,
                    'Purity', w5,
                    'ProductSizeId', w6,
                    'IsDefaultSKU', w7,
                    'SKU', w0,
                    'CostMethodId', w8,
                    'HasBom', w7,
                    'ForExchange', w7,
                    'IsDisabled', w7,
                    'IsNew', w7,
                    'IsFeatured', w7,
                    'IsConfigurable', w7,
                    'MappingId', w1,
                    'Parts', w2,
                    'Pieces', w2,
                    'Weight', w5,
                    'NetWeight', w5,
                    'Variance', w5,
                    'PointerWeight', w5,
                    'Rate', w5,
                    'UnitLabour', w5,
                    'PriceMarkup', w5,
                    'LaborMarkup', w5,
                    'DiamondPieces', w2,
                    'DiamondWeight', w5,
                    'StonePieces', w2,
                    'StoneWeight', w5,
                    'OtherPieces', w2,
                    'OtherWeight', w5,
                    'ImageName', w9,
                    'Image1', w9,
                    'Image2', w9,
                    'Image3', w9,
                    'Remarks', w0,
                    'BOMDetails', w10,
                    'LaborDetails', w11,
                    'InspectionDetails', w12,
                    'SequenceDetails', w13,
                    'MoldsDetails', w14,
                    'SalesCostMethodId', w8,
                    'PurchaseCostMethodId', w8,
                    'HSN', w1,
                    'TaxCode', w1,
                    'Image4', w9,
                    'Image5', w9,
                    'Image6', w9,
                    'Image7', w9,
                    'Image8', w9,
                    'Video1', w9,
                    'Video2', w9,
                    'ProductPartyDetails', w15
                ]);
            }
        }
    }
}
